export default {
  tipoContato: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  telefone: {
    value: '',
    maxlength: '15',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/contacts/modal/phonemodal-form.js